import { QueryParameters as GetCartQueryParams } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/get";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";

export const getCartQueryParams = (brandToken: string) => {
  return GetCartQueryParams.build({
    brand_tokens: [brandToken],
    exclude_alcohol_disclaimer: false,
    sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
    should_collapse_preorder_groups: true,
  });
};
